/* Enhance Dawn quick-add without replacing native product, variant or cart behavior. */
(() => {
  const Native = customElements.get('quick-add-modal');
  if (!Native) return;
  let activeModal = null;
  const enhance = modal => {
    if (modal.dataset.onaQuickReady) return;
    modal.dataset.onaQuickReady = 'true';
    modal.show = async function(opener) {
      if (this.onaPending) return;
      if (activeModal && activeModal !== this) {
        activeModal.onaRequest?.abort();
        if (activeModal.hasAttribute('open')) activeModal.hide();
      }
      activeModal = this;
      this.onaPending = true;
      const error = opener.closest('ona-product-card')?.querySelector('[data-ona-quick-error]');
      if (error) error.hidden = true;
      opener.setAttribute('aria-disabled', 'true');
      opener.classList.add('loading');
      opener.querySelector('.loading__spinner')?.classList.remove('hidden');
      this.onaRequest = new AbortController();
      const timer = setTimeout(() => this.onaRequest?.abort(), 20000);
      try {
        const response = await fetch(opener.dataset.productUrl, { signal: this.onaRequest.signal });
        if (!response.ok) throw new Error('Product unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const product = html.querySelector('product-info');
        if (!product || !opener.isConnected || !opener.getClientRects().length || activeModal !== this) throw new Error('Product unavailable');
        this.preprocessHTML(product);
        product.querySelectorAll('[data-curtain-pdp-measure], [data-action="measure"], [data-ona-measure-open]').forEach(button => button.remove());
        // Zoom belongs to the full PDP; avoid an overlay inside the options overlay.
        product.querySelectorAll('[data-ona-zoom]').forEach(button => { button.disabled = true; button.setAttribute('aria-label', 'Curtain photograph; open full details to enlarge'); });
        HTMLUpdateUtility.setInnerHTML(this.modalContent, product.outerHTML);
        if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init();
        if (window.ProductModel) window.ProductModel.loadShopifyXR();
        Object.getPrototypeOf(Native.prototype).show.call(this, opener);
      } catch (exception) {
        if (error && opener.isConnected && activeModal === this) { error.textContent = 'Quick shop could not load. Try again or open View details.'; error.hidden = false; }
      } finally {
        clearTimeout(timer);
        this.onaRequest = null;
        this.onaPending = false;
        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');
        opener.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    };
  };
  const scan = () => {
    document.querySelectorAll('quick-add-modal.ona-quick-shop').forEach(enhance);
    document.querySelectorAll('.ona-quick-opener[hidden]').forEach(opener => {
      const modal = document.querySelector(opener.dataset.modal);
      if (modal?.dataset.onaQuickReady) opener.hidden = false;
    });
  };
  scan();
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) scan();
  }).observe(document.body, { childList:true, subtree:true });
})();
